<template lang="pug">
  .ingredient-item
    div
      .ingredient-item__title {{ item.name }}
      .ingredient-item__subtitle
        span(
          class="break-word"
          v-if="item.stock.farm"
          title="Склад ферми") Ф |
        span(class="break-word") {{ item.stock.name }}
    .ingredient-item__value
      ui-number-input(
        small
        :postfix="'base.min' | translate"
        hide-controls
        :blocked="item.plan_weight === 0 && min === 0"
        :disabled="!hasPermission('schedule', 'change')"
        v-model="min"
        @input="onChange")
        | {{ min }}
</template>

<script>
import UiNumberInput from '@/components/ui/ui-number-input/UiNumberInput.vue'

export default {
  name: 'IngredientItem',

  components: {
    UiNumberInput
  },

  props: {
    item: Object
  },

  mounted () {
    this.min = Math.floor(this.item.mix_load_time / 60)
  },

  data: () => ({
    min: 0
  }),

  methods: {
    onChange () {
      this.item.mix_load_time = this.min * 60
      this.$emit('on-change')
    }
  }
}
</script>

<style lang="scss" scoped>
  .ingredient-item {
    padding: 6px 20px;
    display: flex;
    align-items: center;
    position: relative;

    &__title {
      width: 200px;
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 5px;
    }

    &__subtitle {
      font-size: 12px;
      font-weight: 300;
      display: flex;
      align-items: center;

      span:not(:last-child) {
        margin-right: 5px;
      }
    }

    &__value {
      display: flex;
      justify-content: flex-end;
      width: 50px;
      font-size: 15px;
      white-space: nowrap;
      text-transform: lowercase;
      cursor: pointer;
      border-radius: 6px;
      padding: 3px 6px;
      transition: background 0.2s;
      background: #EEEEEE;

      &:hover {
      }

      &:has(input) {
        background: #DDF2E3;
        cursor: text;
      }
    }
  }
  .not-active {
    .ingredient-item__value {
       background: #e6e6e6;
    }
  }
  .break-word {
    word-break: break-word;
  }
</style>
